export enum STORAGE_KEYS {
  traceToken = 'traceToken',
}
